/**
 * 서류/사진 등록 — 기사+장비 상세 페이지 (Index 의 페어)
 *
 * Ui.Div 타겟. 한 기사(editmemnum)+장비(carnum) 조합의 서류 전체를 4개 탭으로 그룹:
 *   D1: 유효기간 없음 (hasDate=0)
 *   D2: 유효기간이 검사날짜 시작일 기준 (hasDate=1, moretype=2) — form_tab=2
 *   D3: 유효기간이 검사하고 끝나는 기준 (hasDate=1, moretype=3) — form_tab=3
 *   D4: 기사 서류 (hasDate=0, moretype=4) — form_tab=4
 */
import Util from '../../../Common/Util';
export default class Detail {
    constructor() {
        this.data = null;
    }

    destroy() {
        $(`#${this.id}`).off();
        $j.Common.EventBus.offNamespace($j.getNS(this));
    }

    init() {
        this.draw();
        this.initHandler();
        this.subscribeBus();
    }

    subscribeBus() {
        const self = this;
        const ns = $j.getNS(this);

        $j.Common.EventBus.on(ns, 'BS:close', (e, payload) => {
            if (!payload || payload.target !== '$j.F.Docs.v1.UploadSheet') return;
            self.refresh();
        });

        $j.Common.EventBus.on(ns, 'img-editor:saved', (e, payload) => {
            const imgId = payload.imgId;
            const docId = G5['currentEditDocId'];
            $.ajax({
                type: 'POST', url: '/m/ajax/docs/save', dataType: 'json',
                data: { docId, imgId },
                success: (r) => {
                    if (!r.result) { Util.swalert('시스템에러로 저장하지 못했습니다.'); return; }
                    $('#' + G5['EDITOR_ID']).remove();
                    self._applyImageEditResult(r);
                    $j.Common.EventBus.trigger('docs:image-edited', {
                        docId: r.doc_id, dataCode: r.data_code,
                        imgRelId: r.img_rel_id, imageUrl: r.image_url, thumbUrl: r.thumb_url
                    });
                }
            });
        });
    }

    _applyImageEditResult(r) {
        const list = this.data?.uploadsByCode?.[r.data_code] || [];
        list.forEach(row => {
            if (row && row[7] == r.doc_id) {
                row[1]  = r.image_url;
                row[2]  = r.thumb_url;
                row[10] = r.img_rel_id;
            }
        });
    }

    // ─── 탭 분류 ──────────────────────────────────

    _groupTitlesByTab(titles) {
        const out = { D1: [], D2: [], D3: [], D4: [] };
        titles.forEach(t => {
            // 칸은 마스터가 정한다 (g5_document_types.form_tab). 예전엔 main_tab·limit_type·car_person
            // 세 값을 여기서 겹쳐 읽어 칸을 정했는데, 그 셋이 만드는 결과가 네 가지뿐이라 한 칸으로 합쳤다.
            const hdd = 'D' + (t.form_tab || 1);
            if (!out[hdd]) out[hdd] = [];
            out[hdd].push(t);
        });
        return out;
    }

    _groupCustomsByTab(customs) {
        const out = { D1: [], D2: [], D3: [], D4: [] };
        customs.forEach(c => {
            const hdd = 'D' + c.doc_subcode;
            if (!out[hdd]) out[hdd] = [];
            // Box 렌더용 title 형태로 변환
            out[hdd].push({
                num: c.num,
                doc_code: c.doc_code,
                doc_name: c.user_title,
                doc_name_full: c.user_title,
            });
        });
        return out;
    }

    // ─── 렌더링 ──────────────────────────────────

    draw() {
        const d = this.data || {};
        const byTab     = this._groupTitlesByTab(d.titles || []);
        const customByTab = this._groupCustomsByTab(d.customDocs || []);
        const plate     = this._escHtml(d.car_platenumber || '');
        const driver    = this._escHtml(d.driver_mem_name || '');

        $(`#${this.id}`).html(`
        <div class="dv1" id="docDivBox">
            <button type="button" class="dv1-back js-back">
                <i class="fas fa-chevron-left"></i>차량 목록
            </button>

            <section class="jb-card">
                <h2 class="jb-card-hd"><i class="fas fa-file-lines"></i>${plate} · 유효기간 없는 서류</h2>
                <div class="dv1-grid" id="inshowtype1">
                    ${this._renderTab(byTab.D1, customByTab.D1, { hasDate: 0, moretype: 1 })}
                </div>
            </section>

            <section class="jb-card">
                <h2 class="jb-card-hd"><i class="fas fa-calendar-check"></i>${plate} · 유효기간 있는 서류</h2>
                <div class="dv1-sub">유효기간이 검사한 날짜로 계산되는 서류</div>
                <div class="dv1-grid" id="inshowtype2">
                    ${this._renderTab(byTab.D2, customByTab.D2, { hasDate: 1, moretype: 2 })}
                </div>
                <div class="dv1-sub">유효기간이 검사하고 끝나는 날짜로 계산되는 서류</div>
                <div class="dv1-grid" id="inshowtype3">
                    ${this._renderTab(byTab.D3, customByTab.D3, { hasDate: 1, moretype: 3 })}
                </div>
            </section>

            <section class="jb-card">
                <h2 class="jb-card-hd"><i class="fas fa-id-card"></i>${driver} 기사의 서류</h2>
                <div class="dv1-grid" id="inshowtype4">
                    ${this._renderTab(byTab.D4, customByTab.D4, { hasDate: 0, moretype: 4 })}
                </div>
            </section>
        </div>`);
    }

    _renderTab(titles, customs, ctx) {
        const uploads = this.data.uploadsByCode || {};
        const titleBoxes = titles.map((t, i) => this._renderBox({
            titleIdx: i, title: t, uploads: uploads[t.doc_code] || [],
            hasDate: ctx.hasDate, moretype: ctx.moretype, seltyett: ''
        })).join('');
        const customBoxes = customs.map((t, i) => this._renderBox({
            titleIdx: -1, title: t, uploads: uploads[t.doc_code] || [],
            hasDate: ctx.hasDate, moretype: ctx.moretype, seltyett: ''
        })).join('');
        const addBtn = this._renderAddButton(ctx);
        return titleBoxes + customBoxes + addBtn;
    }

    _renderBox(ctx) {
        const t = ctx.title;
        const uploads = ctx.uploads;
        const uploadCnt = uploads.length;
        // dataCode 는 항상 doc_code. uploadsByCode 키·백엔드(upload/delete/expire)의 data_code 가
        // 모두 doc_code 컬럼 기준이므로, 커스텀 서류(doc_code>100)도 num 이 아닌 doc_code 를 써야
        // 클릭 시 BS 이미지 조회·삭제·만료갱신이 일치한다.
        const dataCode = t.doc_code;
        const docName = t.doc_name_full || t.doc_name || '';
        const eTit    = t.doc_name || docName;

        let showNum, eafn, oldval;
        if (uploadCnt > 0) {
            const first = uploads[0];
            eafn    = first[1];
            oldval  = first[4] || '';
            showNum = first[7];
        } else {
            eafn    = '';
            oldval  = '';
            showNum = -1;
        }
        // 업로드 행이 없어도 g5_company 등록값(co_number/co_bank1)이 있으면 사업자번호/계좌번호 칸에 표시
        if (!oldval) {
            if (dataCode == 12 && this.data?.bankDisplay) oldval = this.data.bankDisplay;
            else if (dataCode == 5 && this.data?.coNumber) oldval = this.data.coNumber;
        }

        const has = uploadCnt > 0;
        const thumbStyle = has && eafn ? ` style="background-image:url('${eafn}')"` : '';
        // 배지는 '2장 이상'일 때만 (Index.js 와 같은 규칙)
        const badge = uploadCnt > 1 ? `<span class="doc-tile-badge">${uploadCnt}</span>` : '';
        const ico = has ? '' : '<i class="fas fa-camera doc-tile-ico"></i>';
        // 유효기간이 있는 서류만 만료일을 타일에 노출한다 — 서류의 유효성 자체라 열어보지 않고 보여야 한다
        const meta = (ctx.hasDate == 1 && oldval)
            ? `<span class="doc-tile-meta${this._isExpired(oldval) ? ' is-expired' : ''}">~${this._escHtml(oldval)}</span>`
            : '';

        // 구 마크업의 체크박스·hidden(eadataval_*)·배지 id(eadatacnt_*)는 읽는 쪽이 없어 걷어냈다.
        return `
        <button type="button" class="doc-tile js-doc-box${has ? '' : ' is-empty'}"
             data-data-code="${dataCode}"
             data-doc-name="${this._escAttr(docName)}"
             data-has-date="${ctx.hasDate}"
             data-old-val="${this._escAttr(oldval)}"
             data-show-num="${showNum}"
             data-moretype="${ctx.moretype}"
             data-seltyett=""
             id="userDataphoto_${dataCode}_1"
             data_rsno="${showNum}">
            <span class="doc-tile-thumb"${thumbStyle}>${ico}${badge}</span>
            <span class="doc-tile-name">${this._escHtml(eTit)}</span>
            ${meta}
        </button>`;
    }

    // YYYY-MM-DD 만료 판정. 형식이 아니면 판정하지 않는다(레거시 값에 메모가 섞인 경우가 있다)
    _isExpired(s) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
        return dayjs(s).isBefore(dayjs(), 'day');
    }

    _renderAddButton(ctx) {
        return `
        <button type="button" class="doc-tile is-add js-doc-add" id="morebtn_${ctx.moretype}"
             data-has-date="${ctx.hasDate}"
             data-moretype="${ctx.moretype}">
            <span class="doc-tile-thumb"><i class="fas fa-plus doc-tile-ico"></i></span>
            <span class="doc-tile-name">추가</span>
        </button>`;
    }

    // ─── 이벤트 ──────────────────────────────────

    initHandler() {
        const self = this;
        const $el = $(`#${this.id}`);

        $el.on('click', '.js-doc-box', function(){ self._onClickDocBox($(this)); });
        $el.on('click', '.js-doc-add', function(){ self._onClickAdd($(this)); });

        // 차량 목록으로 — history.back() 이 아니라 목적지를 직접 지정한다.
        // 알림·딥링크로 이 페이지에 바로 들어오면 돌아갈 히스토리가 없다. (replace: 안드로이드 백버튼 대응)
        $el.on('click', '.js-back', () => location.replace('/m/docs/v1'));
    }

    /**
     * 종류의 총 장수 상한 — 마스터(`g5_document_types.max_pages`)가 `titles` 에 실려 온다.
     * 커스텀 서류(doc_code>100)는 `titles` 에 없어 0 이 되고, 시트가 기본값으로 돌아간다.
     */
    _maxPagesOf(dataCode) {
        const t = (this.data?.titles || []).find((x) => x.doc_code == dataCode);
        return t ? (parseInt(t.max_pages) || 0) : 0;
    }

    /**
     * 더 올릴 수 있는 장수 — **서버가 센다** (DocService::remainByCode).
     * 화면의 업로드 목록으로는 못 센다: 공통서류 칸은 소속 기사 전원의 장을 모아 보여준다.
     */
    _remainPagesOf(dataCode) {
        const r = this.data?.remainByCode || {};
        return (r[dataCode] == null) ? null : (parseInt(r[dataCode]) || 0);
    }

    _onClickDocBox($box) {
        const dataCode = parseInt($box.data('data-code'));
        const docName  = $box.data('doc-name');
        const hasDate  = parseInt($box.data('has-date'));
        const oldVal   = $box.data('old-val') || '';
        const showNum  = parseInt($box.data('show-num'));
        const moretype = parseInt($box.data('moretype'));

        const uploads = this.data.uploadsByCode?.[dataCode] || [];

        $j.Ui.BS.open({
            target: '$j.F.Docs.v1.UploadSheet',
            fixedHeight: true,
            data: {
                tar: $box[0], docName, hasDate, dataCode, oldDate: oldVal,
                subCode: 1, tarMaxnum: 1, showImg: '',
                showNum, intype: 0, sstype: moretype, seltyett: '',
                existingData: uploads,
                maxPages: this._maxPagesOf(dataCode),
                remainPages: this._remainPagesOf(dataCode),
                editmembernum: this.data.editmemnum,
                carnum: this.data.carnum,
                userGroups: (this.data.userGroups || '').split('|').filter(Boolean),
                bankLocked: !!this.data.bankLocked,
            }
        });
    }

    _onClickAdd($btn) {
        const hasDate  = parseInt($btn.data('has-date'));
        const moretype = parseInt($btn.data('moretype'));

        $j.Ui.BS.open({
            target: '$j.F.Docs.v1.UploadSheet',
            fixedHeight: true,
            data: {
                tar: $btn[0], docName: '', hasDate, dataCode: 9999,
                oldDate: '', subCode: 1, tarMaxnum: 1, showImg: '',
                showNum: 99999, intype: moretype, sstype: 0, seltyett: '',
                existingData: [],
                editmembernum: this.data.editmemnum,
                carnum: this.data.carnum,
                userGroups: (this.data.userGroups || '').split('|').filter(Boolean),
            }
        });
    }

    // ─── Refresh ──────────────────────────────────

    refresh() {
        const self = this;
        const scrollTop = $(window).scrollTop();
        const carnum = this.data.carnum;
        const editmemnum = this.data.editmemnum;
        $.ajax({
            type: 'GET', url: `/m/ajax/docs/v1/car/${carnum}`, dataType: 'json',
            data: { editmemnum },
            success: (res) => {
                if (!res.result) return;
                self.data = res.data;
                self.draw();
                $(window).scrollTop(scrollTop);
            }
        });
    }

    _escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    _escAttr(s) { return this._escHtml(s); }
}
